import useRTL from "../../customHooks/useRTL";
type Props = {
  img?: string;

}
const AuthBackground:React.FC<Props> = ({ img }) => {
  const isRTL = useRTL();
  return (
    <>
      <div
        className="d-none d-md-block position-absolute w-50 h-100 bg-size-cover"
        style={{
          right: isRTL ? "unset" : 0,
          left: isRTL ? 0 : "unset",

          zIndex: -1,
          backgroundImage: `${
            img ? `url(${img})` : "url(/assets/img/account/signin-img.jpg)"
          }`,
        }}
      ></div>
    </>
  );
};

export default AuthBackground;
